import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { CitizensGroupSummaries } from './citizens-group-summaries.model';
import * as CitizensGroupSummariesActions from './citizens-group-summaries.actions';

export const citizensGroupSummariesesFeatureKey = 'citizensGroupSummarieses';

export interface State extends EntityState<CitizensGroupSummaries> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensGroupSummaries> = createEntityAdapter<CitizensGroupSummaries>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensGroupSummariesActions.addCitizensGroupSummaries,
    (state, action) => adapter.addOne(action.citizensGroupSummaries, state)
  ),
  on(CitizensGroupSummariesActions.upsertCitizensGroupSummaries,
    (state, action) => adapter.upsertOne(action.citizensGroupSummaries, state)
  ),
  on(CitizensGroupSummariesActions.addCitizensGroupSummariess,
    (state, action) => adapter.addMany(action.citizensGroupSummariess, state)
  ),
  on(CitizensGroupSummariesActions.upsertCitizensGroupSummariess,
    (state, action) => adapter.upsertMany(action.citizensGroupSummariess, state)
  ),
  on(CitizensGroupSummariesActions.updateCitizensGroupSummaries,
    (state, action) => adapter.updateOne(action.citizensGroupSummaries, state)
  ),
  on(CitizensGroupSummariesActions.updateCitizensGroupSummariess,
    (state, action) => adapter.updateMany(action.citizensGroupSummariess, state)
  ),
  on(CitizensGroupSummariesActions.deleteCitizensGroupSummaries,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensGroupSummariesActions.deleteCitizensGroupSummariess,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensGroupSummariesActions.loadCitizensGroupSummariess,
    (state, action) => adapter.setAll(action.citizensGroupSummariess, state)
  ),
  on(CitizensGroupSummariesActions.clearCitizensGroupSummariess,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
